<style></style>

<template>
    <base-collapse 
        :styleClasses="['variant-'+variant, ...styleClasses]"
        :visible="visible"
        :accordion="accordion"
        >
        <template #trigger>
            <div class="arrow" :class="arrow_class"></div>
            <div class="dropdown-line" v-if="showLine"></div>
            <div class="trigger-label">
                <slot name="trigger-label"></slot>
            </div>
        </template>
        <template #collapsed-content>
            <slot name="collapsed-content"></slot>
        </template>
    </base-collapse>
</template>

<script>
    import BaseCollapse from './BaseCollapse'
    
    export default {
        components: {
            BaseCollapse
        },
        props: {
            variant: {
                type: String,
                default: 'primary'
            },
            showLine: {
                type: Boolean,
                default: true
            },
            visible: {
                type: Boolean,
                default: false
            },
            accordion: {
                type: String,
                default: null
            },
            arrow_class: {
                type: Object,
                default: {}
            }
        },
        data() {
            return {
                styleClasses: [
                    'ta-resources-section',
                    'border-heavy',
                    'w-100',
                    'mb-2',
                    'arrow-collapse',
                    'clearfix',
                ],
            }
        },
        mounted() {
        },
        methods: {}
    
}
</script>
